export enum MuiIconFont {
  MIELE = 'miele',
  MIELE_PROGRAM_SYMBOLS = 'miele-program-symbols',
  FONTAWESOME = 'fa'
}
